// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from "cross-fetch";
import akmApi from "../../../../../../apis/akmApi";
import eduprimeApi from "../../../../../../apis/eduprimeApi";
import { CONFIG_AKM } from "../../../../../../config/ConfigAkm";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import { CONFIG_API_BE } from "../../../../../../config";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function AutocompleteSearchCity(props) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        console.log("====================================");
        console.log("idProvinsi", props.idProvinsi);
        console.log("====================================");
        if (search !== null) {
            (async () => {
                setOpen(true);
                await eduprimeApi
                    .get(CONFIG_API_BE.API_GET_KAB_KOTA + props.idProvinsi)
                    .then((data) => {
                        console.info("data kota", data.data.list_kab_kota);
                        const listCity = data.data.list_kab_kota;
                        if (listCity.length > 0) {
                            setOptions(data.data.list_kab_kota);
                        } else {
                            setOptions([]);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error Response Fetch City", error);
                    });
            })();
        }
        return () => {
            setSearch(null);
        };
    });

    return (
        <Autocomplete
            size="small"
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.NAMA_KABUPATEN_KOTA === value.NAMA_KABUPATEN_KOTA}
            getOptionLabel={(option) => option.NAMA_KABUPATEN_KOTA}
            options={options}
            loading={loading}
            disableClearable={true}
            onChange={(event, value) => {
                console.info("value kota nih", value.ID_KABUPATEN_KOTA);
                props.handleChangeKota(value.ID_KABUPATEN_KOTA);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cari City"
                    variant="outlined"
                    onChange={(event) => {
                        setSearch(event.target.value);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
